import { createComponent } from '@carvana/merch-components';

export const ScrollBarTrack = createComponent('div', {
  className:
    'relative h-4 w-full cursor-pointer rounded-full bg-background-muted-subtle'
});
